import { ApolloLink, Observable } from '@apollo/client';
import cookies from 'js-cookie';

function getJwtPayloadFromCookie(jwt) {
    return JSON.parse(atob(jwt.split('.')[1]));
}
function expectedIdentity(_a) {
    var getCache = _a.getCache, getIdentityFromJwtPayload = _a.getIdentityFromJwtPayload, getIdentityFromCache = _a.getIdentityFromCache, onIdentityMismatch = _a.onIdentityMismatch;
    return new ApolloLink(function (operation, forward) {
        var cache = getCache();
        var cookie = cookies.get('deal_at');
        if (!cache || !cookie || operation.operationName === 'Myself') {
            return forward(operation);
        }
        var jwtPayload = getJwtPayloadFromCookie(cookie);
        var identityFromJwtPayload = getIdentityFromJwtPayload(jwtPayload);
        var identityFromCache;
        try {
            identityFromCache = getIdentityFromCache(cache);
        }
        catch (_a) {
            return forward(operation);
        }
        if (identityFromJwtPayload !== identityFromCache) {
            if (onIdentityMismatch) {
                onIdentityMismatch(identityFromJwtPayload, identityFromCache);
            }
            return new Observable(function (observer) {
                var err = new Error("The identity in the JWT (\"" + identityFromJwtPayload + "\") does not match the identity in the Apollo Cache (\"" + identityFromCache + "\"). The operation (\"" + operation.operationName + "\") will be skipped.");
                err.name = 'IdentityMismatchError';
                observer.error(err);
            });
        }
        return forward(operation);
    });
}

export default expectedIdentity;
//# sourceMappingURL=expectedIdentity.js.map
